import type { AppConfig } from "@/models"
import { BasicHttpService } from "@/services/httpHelper"

export class ConfigService extends BasicHttpService {
	constructor() {
		super("")
	}

	async get(): Promise<AppConfig> {
		return await this.returningJson<AppConfig>().get("/api/config.json")
	}
}
